import { IconClock } from '@tabler/icons-react';
import { Tooltip } from '@mantine/core';

export function PriorityIcon({ priority }: { priority: 'normal' | 'urgent' | 'overdue' | undefined }) {
  if (priority === 'overdue') {
    return (
      <Tooltip label="Urgent" position="top" withArrow>
        <IconClock size={14.5} color="#f03e3e" />
      </Tooltip>
    );
  }
  if (priority === 'urgent') {
    return (
      <Tooltip label="Urgent" position="top" withArrow>
        <IconClock size={14.5} color="#ffa94d" />
      </Tooltip>
    );
  }
  return null;
}
